import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminLogin from '../components/AdminLogin';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import './AdminPage.css';


Modal.setAppElement('#root');

function AdminPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [fridayEvent, setFridayEvent] = useState({
    day: 'friday',
    active: false,
    flyer: "",
    pistaPrice: 0,
    camarotePrice: 0,
    camaroteOpenPrice: 0,
    ingressoPrice: 0,
    pistaActive: false,
    camaroteActive: false,
    camaroteOpenActive: false,
    ingressoActive: false
  });
  const [saturdayEvent, setSaturdayEvent] = useState({
    day: 'saturday',
    active: false,
    flyer: "",
    pistaPrice: 0,
    camarotePrice: 0,
    camaroteOpenPrice: 0,
    ingressoPrice: 0,
    pistaActive: false,
    camaroteActive: false,
    camaroteOpenActive: false,
    ingressoActive: false
  });
  const [comingSoonEvent, setComingSoonEvent] = useState({
    day: 'em_breve',
    active: false,
    flyer: "",
    type: 'em_breve'
  });

  
  const [customEvents, setCustomEvents] = useState([]); 

  const [isModalOpen, setIsModalOpen] = useState(false); 
  const [customEvent, setCustomEvent] = useState({
    eventName: '',
    eventDate: '',
    day: '',
    pistaActive: false,
    pistaPrice: 0,
    camaroteActive: false,
    camarotePrice: 0,
    camaroteOpenActive: false,
    camaroteOpenPrice: 0,
    ingressoActive: false,
    ingressoPrice: 0,
    flyer: null
  });
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);
  const [paymentsTab, setPaymentsTab] = useState('confirmados');
  const [allPayments, setAllPayments] = useState([]);
  const [editingEventId, setEditingEventId] = useState(null);
  const [editEventPrices, setEditEventPrices] = useState({
    pistaPrice: '',
    camarotePrice: '',
    camaroteOpenPrice: '',
    ingressoPrice: '',
    pistaActive: false,
    camaroteActive: false,
    camaroteOpenActive: false,
    ingressoActive: false
  });
  const [currentPrices, setCurrentPrices] = useState({
    pistaPrice: '',
    camarotePrice: '',
    camaroteOpenPrice: '',
    ingressoPrice: ''
  }); 

  const fetchCustomEvents = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/custom-events`)
      .then(response => {
        setCustomEvents(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar eventos personalizados:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao carregar eventos personalizados.',
          confirmButtonColor: '#2196F3'
        });
      });
  };

  // Carregar eventos existentes quando autenticado
  useEffect(() => {
    if (isAuthenticated) {
      // Carregar eventos regulares
      axios.get(`${process.env.REACT_APP_API_URL}/events`)
        .then(response => {
          const events = response.data;
          events.forEach(event => {
            if (event.day === 'friday') {
              setFridayEvent({
                day: 'friday',
                active: event.active || false,
                flyer: "", // Não carregar flyer como arquivo, apenas manter string vazia
                pistaPrice: event.pistaPrice || 0,
                camarotePrice: event.camarotePrice || 0,
                camaroteOpenPrice: event.camaroteOpenPrice || 0,
                ingressoPrice: event.ingressoPrice || 0,
                pistaActive: !!event.pistaPrice,
                camaroteActive: !!event.camarotePrice,
                camaroteOpenActive: !!event.camaroteOpenPrice,
                ingressoActive: !!event.ingressoPrice
              });
            } else if (event.day === 'saturday') {
              setSaturdayEvent({
                day: 'saturday',
                active: event.active || false,
                flyer: "", // Não carregar flyer como arquivo, apenas manter string vazia
                pistaPrice: event.pistaPrice || 0,
                camarotePrice: event.camarotePrice || 0,
                camaroteOpenPrice: event.camaroteOpenPrice || 0,
                ingressoPrice: event.ingressoPrice || 0,
                pistaActive: !!event.pistaPrice,
                camaroteActive: !!event.camarotePrice,
                camaroteOpenActive: !!event.camaroteOpenPrice,
                ingressoActive: !!event.ingressoPrice
              });
            } else if (event.day === 'em_breve') {
              setComingSoonEvent({
                day: 'em_breve',
                active: event.active || false,
                flyer: event.flyer || "",
                type: 'em_breve'
              });
            }
          });
        })
        .catch(error => {
          console.error('Erro ao carregar eventos:', error);
        });

      // Carregar eventos personalizados
      fetchCustomEvents();
      
      // Limpar pagamentos pendentes antigos ao abrir a página
      const cleanupOldPendingPayments = async () => {
        try {
          await axios.delete(`${process.env.REACT_APP_API_URL}/payments/cleanup-old-pending`);
        } catch (error) {
          console.error('Erro ao limpar pagamentos pendentes antigos:', error);
        }
      };
      
      cleanupOldPendingPayments();
      // Carregar pagamentos
      fetchPayments();
    }
  }, [isAuthenticated]);

  const fetchPayments = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/payments/all`)
      .then(response => {
        setAllPayments(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar pagamentos:', error);
      });
  };


  const openManageModal = () => {
    fetchCustomEvents(); 
    setIsManageModalOpen(true);
  };

  
  const closeManageModal = () => {
    setIsManageModalOpen(false);
  };


    
    const deleteCustomEvent = (eventId) => {
      console.log("Tentando excluir o evento com ID:", eventId); 
      if (window.confirm('Tem certeza que deseja excluir este evento?')) {
        axios.delete(`${process.env.REACT_APP_API_URL}/custom-events/${eventId}`)
          .then((response) => {
            console.log("Resposta do servidor ao excluir:", response.data); 
            setCustomEvents(customEvents.filter(event => event._id !== eventId));
            Swal.fire({
              icon: 'success',
              title: 'Sucesso',
              text: 'Evento excluído com sucesso.',
              confirmButtonColor: '#4CAF50'
            });
          })
          .catch(error => {
            console.error('Erro ao excluir o evento:', error.response ? error.response.data : error.message); 
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: 'Erro ao excluir o evento.',
              confirmButtonColor: '#2196F3'
            });
          });
      }
    };
    
  


  const handleEventChange = (day, key, value) => {
    if (day === 'em_breve') {
      setComingSoonEvent({ ...comingSoonEvent, [key]: value });
    } else {
      const setEvent = day === 'friday' ? setFridayEvent : setSaturdayEvent;
      const event = day === 'friday' ? fridayEvent : saturdayEvent;
      setEvent({ ...event, [key]: value });
    }
  };

  const handleFileChange = (day, e) => {
    if (day === 'em_breve') {
      setComingSoonEvent({ ...comingSoonEvent, flyer: e.target.files[0] });
    } else {
      const setEvent = day === 'friday' ? setFridayEvent : setSaturdayEvent;
      const event = day === 'friday' ? fridayEvent : saturdayEvent;
      setEvent({ ...event, flyer: e.target.files[0] });
    }
  };

  const validateEvent = (event) => {
    if (event.day !== 'em_breve') {
      if (event.active && (!event.flyer || (!event.pistaActive && !event.camaroteActive && !event.camaroteOpenActive && !event.ingressoActive))) {
        return false;
      }
    } else {
      if (event.active && !event.flyer) {
        return false;
      }
    }
    return true;
  };

  const submitEvents = () => {
    if (!fridayEvent.active && !saturdayEvent.active && !comingSoonEvent.active) {
      
      axios.post(`${process.env.REACT_APP_API_URL}/events/clear-all`)
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso',
            text: 'Todos os eventos foram removidos com sucesso.',
            confirmButtonColor: '#4CAF50'
          });
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao limpar eventos.',
            confirmButtonColor: '#2196F3'
          });
          console.error('Erro ao limpar eventos:', error);
        });
      return;
    }

    const events = [];
    if (fridayEvent.active) {
      if (!validateEvent(fridayEvent)) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Evento de sexta-feira precisa de uma imagem e pelo menos uma opção de preço.',
          confirmButtonColor: '#FF9800'
        });
        return;
        return;
      }
      events.push(fridayEvent);
    }
    if (saturdayEvent.active) {
      if (!validateEvent(saturdayEvent)) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Evento de sábado precisa de uma imagem e pelo menos uma opção de preço.',
          confirmButtonColor: '#FF9800'
        });
        return;
        return;
      }
      events.push(saturdayEvent);
    }
    if (comingSoonEvent.active) {
      if (!validateEvent(comingSoonEvent)) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Evento "EM BREVE" precisa de uma imagem.',
          confirmButtonColor: '#FF9800'
        });
        return;
        return;
      }
      events.push(comingSoonEvent);
    }

    
    axios.post(`${process.env.REACT_APP_API_URL}/events/clear-all`)
      .then(() => {
        
        return Promise.all(events.map(event => {
          const formData = new FormData();
          formData.append('day', event.day);
          formData.append('type', event.type || 'regular');
          
          // Enviar preços apenas se estiverem ativos e tiverem valor
          if (event.pistaActive) {
            formData.append('pistaPrice', event.pistaPrice || 0);
          } else {
            formData.append('pistaPrice', '');
          }
          if (event.camaroteActive) {
            formData.append('camarotePrice', event.camarotePrice || 0);
          } else {
            formData.append('camarotePrice', '');
          }
          if (event.camaroteOpenActive) {
            formData.append('camaroteOpenPrice', event.camaroteOpenPrice || 0);
          } else {
            formData.append('camaroteOpenPrice', '');
          }
          if (event.ingressoActive) {
            formData.append('ingressoPrice', event.ingressoPrice || 0);
          } else {
            formData.append('ingressoPrice', '');
          }
          
          // Só enviar flyer se for um arquivo novo, senão manter o existente
          if (event.flyer && typeof event.flyer !== 'string') {
            formData.append('flyer', event.flyer);
          } else if (event.flyer && typeof event.flyer === 'string' && event.flyer.startsWith('/uploads/')) {
            // Se for string (caminho existente), enviar como está para manter o flyer
            formData.append('flyer', event.flyer);
          }

          return axios.post(`${process.env.REACT_APP_API_URL}/events`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        }));
      })
      .then(responses => {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: 'Eventos salvos com sucesso!',
          confirmButtonColor: '#4CAF50'
        });
        console.log('Eventos salvos:', responses.map(response => response.data));
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao salvar eventos.',
          confirmButtonColor: '#2196F3'
        });
        console.error('Erro ao salvar eventos:', error);
      });
  };

  const clearNames = (day) => {
    if (window.confirm(`ATENÇÃO, TODOS OS NOMES DA LISTA DE ${day.toUpperCase()} SERÃO APAGADOS. Você deseja continuar?`)) {
      axios.post(`${process.env.REACT_APP_API_URL}/events/clear-names`, { day })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso',
            text: response.data.message,
            confirmButtonColor: '#4CAF50'
          });
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao apagar a lista de nomes.',
            confirmButtonColor: '#2196F3'
          });
          console.error('Erro ao apagar a lista de nomes:', error);
        });
    }
  };

  const exportNames = (day) => {
    window.open(`${process.env.REACT_APP_API_URL}/events/export-names/${day}`, '_blank');
  };

  const exportNamesToExcel = (day) => {
    window.open(`${process.env.REACT_APP_API_URL}/events/export-names-excel/${day}`, '_blank');
  };

  const handleCustomEventChange = (key, value) => {
    setCustomEvent({ ...customEvent, [key]: value });
  };

  const handleCustomFileChange = (e) => {
    setCustomEvent({ ...customEvent, flyer: e.target.files[0] });
  };

  const openEditPricesModal = (event) => {
    setEditingEventId(event._id);
    // Guardar valores atuais para placeholder
    setCurrentPrices({
      pistaPrice: event.pistaPrice || '',
      camarotePrice: event.camarotePrice || '',
      camaroteOpenPrice: event.camaroteOpenPrice || '',
      ingressoPrice: event.ingressoPrice || ''
    });
    // Inicializar campos vazios
    setEditEventPrices({
      pistaPrice: '',
      camarotePrice: '',
      camaroteOpenPrice: '',
      ingressoPrice: '',
      pistaActive: !!event.pistaPrice,
      camaroteActive: !!event.camarotePrice,
      camaroteOpenActive: !!event.camaroteOpenPrice,
      ingressoActive: !!event.ingressoPrice
    });
  };

  const closeEditPricesModal = () => {
    setEditingEventId(null);
    setEditEventPrices({
      pistaPrice: '',
      camarotePrice: '',
      camaroteOpenPrice: '',
      ingressoPrice: '',
      pistaActive: false,
      camaroteActive: false,
      camaroteOpenActive: false,
      ingressoActive: false
    });
    setCurrentPrices({
      pistaPrice: '',
      camarotePrice: '',
      camaroteOpenPrice: '',
      ingressoPrice: ''
    });
  };

  const handleEditPriceChange = (key, value) => {
    // Se for um campo de preço, converter para número ou string vazia
    if (key.includes('Price')) {
      const numValue = value === '' ? '' : (parseFloat(value) || '');
      setEditEventPrices({ ...editEventPrices, [key]: numValue });
    } else {
      setEditEventPrices({ ...editEventPrices, [key]: value });
    }
  };

  const saveEventPrices = async () => {
    if (!editingEventId) return;
    
    // Se for evento regular (friday ou saturday)
    if (editingEventId === 'friday' || editingEventId === 'saturday') {
      const event = editingEventId === 'friday' ? fridayEvent : saturdayEvent;
      
      // Atualizar o estado local
      const updatedEvent = {
        ...event,
        pistaPrice: editEventPrices.pistaActive ? (editEventPrices.pistaPrice || currentPrices.pistaPrice || 0) : 0,
        camarotePrice: editEventPrices.camaroteActive ? (editEventPrices.camarotePrice || currentPrices.camarotePrice || 0) : 0,
        camaroteOpenPrice: editEventPrices.camaroteOpenActive ? (editEventPrices.camaroteOpenPrice || currentPrices.camaroteOpenPrice || 0) : 0,
        ingressoPrice: editEventPrices.ingressoActive ? (editEventPrices.ingressoPrice || currentPrices.ingressoPrice || 0) : 0,
        pistaActive: editEventPrices.pistaActive,
        camaroteActive: editEventPrices.camaroteActive,
        camaroteOpenActive: editEventPrices.camaroteOpenActive,
        ingressoActive: editEventPrices.ingressoActive
      };

      if (editingEventId === 'friday') {
        setFridayEvent(updatedEvent);
      } else {
        setSaturdayEvent(updatedEvent);
      }

      // Salvar no backend
      const formData = new FormData();
      formData.append('day', editingEventId);
      formData.append('type', 'regular');
      
      // Manter o flyer existente
      if (event.flyer && typeof event.flyer === 'string' && event.flyer.startsWith('/uploads/')) {
        formData.append('flyer', event.flyer);
      }

      // Enviar preços - usar valor digitado ou valor atual se vazio
      if (editEventPrices.pistaActive) {
        formData.append('pistaPrice', editEventPrices.pistaPrice || currentPrices.pistaPrice || 0);
      } else {
        formData.append('pistaPrice', '');
      }
      if (editEventPrices.camaroteActive) {
        formData.append('camarotePrice', editEventPrices.camarotePrice || currentPrices.camarotePrice || 0);
      } else {
        formData.append('camarotePrice', '');
      }
      if (editEventPrices.camaroteOpenActive) {
        formData.append('camaroteOpenPrice', editEventPrices.camaroteOpenPrice || currentPrices.camaroteOpenPrice || 0);
      } else {
        formData.append('camaroteOpenPrice', '');
      }
      if (editEventPrices.ingressoActive) {
        formData.append('ingressoPrice', editEventPrices.ingressoPrice || currentPrices.ingressoPrice || 0);
      } else {
        formData.append('ingressoPrice', '');
      }

      try {
        await axios.post(`${process.env.REACT_APP_API_URL}/events`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        });
        
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: 'Preços atualizados com sucesso!',
          confirmButtonColor: '#4CAF50'
        });
        closeEditPricesModal();
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao atualizar preços.',
          confirmButtonColor: '#2196F3'
        });
        console.error('Erro ao atualizar preços:', error);
      }
    } else {
      // Evento personalizado
      const event = customEvents.find(e => e._id === editingEventId);
      if (!event) return;

      const formData = new FormData();
      formData.append('eventName', event.eventName);
      formData.append('eventDate', event.eventDate);
      formData.append('day', event.day);
      
      // Manter o flyer existente
      if (event.flyer) {
        formData.append('flyer', event.flyer);
      }

      // Enviar preços - usar valor digitado ou valor atual se vazio
      if (editEventPrices.pistaActive) {
        formData.append('pistaPrice', editEventPrices.pistaPrice || currentPrices.pistaPrice || 0);
      } else {
        formData.append('pistaPrice', '');
      }
      if (editEventPrices.camaroteActive) {
        formData.append('camarotePrice', editEventPrices.camarotePrice || currentPrices.camarotePrice || 0);
      } else {
        formData.append('camarotePrice', '');
      }
      if (editEventPrices.camaroteOpenActive) {
        formData.append('camaroteOpenPrice', editEventPrices.camaroteOpenPrice || currentPrices.camaroteOpenPrice || 0);
      } else {
        formData.append('camaroteOpenPrice', '');
      }
      if (editEventPrices.ingressoActive) {
        formData.append('ingressoPrice', editEventPrices.ingressoPrice || currentPrices.ingressoPrice || 0);
      } else {
        formData.append('ingressoPrice', '');
      }

      try {
        await axios.post(`${process.env.REACT_APP_API_URL}/custom-events`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        });
        
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: 'Preços atualizados com sucesso!',
          confirmButtonColor: '#4CAF50'
        });
        fetchCustomEvents();
        closeEditPricesModal();
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao atualizar preços.',
          confirmButtonColor: '#2196F3'
        });
        console.error('Erro ao atualizar preços:', error);
      }
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };



  
const clearCustomEventNames = () => {
  if (window.confirm("ATENÇÃO, TODOS OS NOMES DO EVENTO PERSONALIZADO SERÃO APAGADOS. Você deseja continuar?")) {
    axios.post(`${process.env.REACT_APP_API_URL}/custom-events/clear-names`)
      .then(response => {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: response.data.message,
          confirmButtonColor: '#4CAF50'
        });
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao apagar a lista de nomes do evento personalizado.',
          confirmButtonColor: '#2196F3'
        });
        console.error('Erro ao apagar a lista de nomes:', error);
      });
  }
};

const adicionarConvidados = async () => {
  try {
    // Perguntar ao usuário o número de convidados
    const { value: quantidade } = await Swal.fire({
      title: 'Quantos nomes deseja adicionar?',
      input: 'number',
      inputLabel: 'Digite o número de convidados:',
      inputPlaceholder: 'Quantidade de convidados', 
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      inputValidator: (value) => {
        if (!value || isNaN(value) || value <= 0) {
          return 'Por favor, insira um número válido!';
        }
      },
    });

    if (!quantidade) return; // Cancelado pelo usuário

    // Criar os inputs para os nomes
    const { value: nomes } = await Swal.fire({
      title: 'Insira os nomes:',
      html: new Array(Number(quantidade))
        .fill(0)
        .map((_, index) => `<input id="nome-${index}" class="swal2-input" placeholder="Nome ${index + 1}" />`)
        .join(''),
      focusConfirm: false,
      preConfirm: () => {
        const inputValues = [];
        for (let i = 0; i < quantidade; i++) {
          const nome = document.getElementById(`nome-${i}`).value.trim();
          if (!nome) {
            return Swal.showValidationMessage('Todos os campos devem ser preenchidos!');
          }
          inputValues.push(nome);
        }
        return inputValues;
      },
    });

    if (!nomes) return; // Cancelado pelo usuário

    // Salvar os nomes no localStorage
    localStorage.setItem('convidados', JSON.stringify(nomes));

    // Recuperar os nomes do localStorage
    const convidados = JSON.parse(localStorage.getItem('convidados'));

    // Enviar os nomes ao backend
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/add-names`, { names: convidados });

    // Exibir mensagem de sucesso
    Swal.fire({
      icon: 'success',
      title: 'Sucesso',
      text: response.data.message,
      confirmButtonColor: '#4CAF50'
    });

    // Limpar o localStorage
    localStorage.removeItem('convidados');
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: 'Erro ao adicionar convidados.',
      confirmButtonColor: '#2196F3'
    });
    console.error('Erro ao adicionar convidados:', error);
  }
};


const exportCustomEventNames = () => {
  window.open(`${process.env.REACT_APP_API_URL}/custom-events/export-names`, '_blank');
};


const exportCustomEventNamesToExcel = () => {
  window.open(`${process.env.REACT_APP_API_URL}/custom-events/export-names-excel`, '_blank');
};



  const handleSaveCustomEvent = () => {
    
    if (!customEvent.eventDate || !customEvent.day || !customEvent.flyer) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Preencha todos os campos obrigatórios.',
        confirmButtonColor: '#FF9800'
      });
      return;
      return;
    }
  
    const formData = new FormData();
    formData.append('eventName', customEvent.eventName);
    formData.append('eventDate', customEvent.eventDate);
    formData.append('day', customEvent.day);
    formData.append('flyer', customEvent.flyer);
  
    if (customEvent.pistaActive) {
      formData.append('pistaPrice', customEvent.pistaPrice);
    }
    if (customEvent.camaroteActive) {
      formData.append('camarotePrice', customEvent.camarotePrice);
    }
    if (customEvent.camaroteOpenActive) {
      formData.append('camaroteOpenPrice', customEvent.camaroteOpenPrice);
    }
    if (customEvent.ingressoActive) {
      formData.append('ingressoPrice', customEvent.ingressoPrice);
    }
  
    axios.post(`${process.env.REACT_APP_API_URL}/custom-events`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
    .then(response => {
      Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: 'Evento personalizado salvo com sucesso!',
        confirmButtonColor: '#4CAF50'
      });
      console.log('Evento salvo:', response.data);
      closeModal(); 
    })
    .catch(error => {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao salvar o evento.',
        confirmButtonColor: '#2196F3'
      });
      console.error('Erro ao salvar o evento:', error);
    });
  };
  

  if (!isAuthenticated) {
    return <AdminLogin onLogin={setIsAuthenticated} />;
  }

  return (
    <div className="admin-page">
      <h1>Administração de Eventos</h1>

      <div>
        <button onClick={openModal}>
          Adicionar evento personalizado
        </button>

        <button onClick={openManageModal}>
          Gerenciar Eventos Personalizados
        </button>
      </div>

      <button onClick={submitEvents}>Salvar Eventos</button>
      <hr />

      {/* Seção de Pagamentos com Abas */}
      <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <h2 style={{ color: '#ffffff', marginBottom: '1rem' }}>Status de Pagamentos</h2>
        
        {/* Abas */}
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', borderBottom: '2px solid rgba(59, 130, 246, 0.3)' }}>
          <button
            onClick={() => setPaymentsTab('confirmados')}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: paymentsTab === 'confirmados' ? '#4CAF50' : 'transparent',
              color: paymentsTab === 'confirmados' ? '#ffffff' : '#ffffff',
              border: 'none',
              borderBottom: paymentsTab === 'confirmados' ? '3px solid #4CAF50' : '3px solid transparent',
              cursor: 'pointer',
              fontWeight: paymentsTab === 'confirmados' ? '700' : '400',
              borderRadius: '8px 8px 0 0',
              transition: 'all 0.3s ease'
            }}
          >
            Confirmados ({allPayments.filter(p => p.status === 'approved').reduce((acc, p) => acc + (p.names?.length || 0), 0)})
          </button>
          <button
            onClick={() => setPaymentsTab('aguardando')}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: paymentsTab === 'aguardando' ? '#FF9800' : 'transparent',
              color: paymentsTab === 'aguardando' ? '#ffffff' : '#ffffff',
              border: 'none',
              borderBottom: paymentsTab === 'aguardando' ? '3px solid #FF9800' : '3px solid transparent',
              cursor: 'pointer',
              fontWeight: paymentsTab === 'aguardando' ? '700' : '400',
              borderRadius: '8px 8px 0 0',
              transition: 'all 0.3s ease'
            }}
          >
            Aguardando ({allPayments.filter(p => p.status !== 'approved').reduce((acc, p) => acc + (p.names?.length || 0), 0)})
          </button>
        </div>

        {/* Conteúdo das Abas */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '8px',
          padding: '1.5rem',
          minHeight: '300px',
          maxHeight: '500px',
          overflowY: 'auto',
          border: '1px solid rgba(59, 130, 246, 0.2)'
        }}>
          {paymentsTab === 'confirmados' ? (
            <div>
              <h3 style={{ color: '#4CAF50', marginBottom: '1rem' }}>Pagamentos Confirmados</h3>
              {allPayments.filter(p => p.status === 'approved').length === 0 ? (
                <p style={{ color: '#ffffff', textAlign: 'center', padding: '2rem' }}>Nenhum pagamento confirmado no momento.</p>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ 
                    width: '100%', 
                    borderCollapse: 'collapse',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: '8px',
                    overflow: 'hidden'
                  }}>
                    <thead>
                      <tr style={{ backgroundColor: 'rgba(76, 175, 80, 0.2)' }}>
                        <th style={{ 
                          padding: '0.75rem', 
                          textAlign: 'left', 
                          color: '#4CAF50', 
                          fontWeight: '700',
                          borderBottom: '2px solid rgba(76, 175, 80, 0.5)'
                        }}>ID</th>
                        <th style={{ 
                          padding: '0.75rem', 
                          textAlign: 'left', 
                          color: '#4CAF50', 
                          fontWeight: '700',
                          borderBottom: '2px solid rgba(76, 175, 80, 0.5)'
                        }}>Data/Hora</th>
                        <th style={{ 
                          padding: '0.75rem', 
                          textAlign: 'left', 
                          color: '#4CAF50', 
                          fontWeight: '700',
                          borderBottom: '2px solid rgba(76, 175, 80, 0.5)'
                        }}>Valor</th>
                        <th style={{ 
                          padding: '0.75rem', 
                          textAlign: 'left', 
                          color: '#4CAF50', 
                          fontWeight: '700',
                          borderBottom: '2px solid rgba(76, 175, 80, 0.5)'
                        }}>Nome</th>
                        <th style={{ 
                          padding: '0.75rem', 
                          textAlign: 'left', 
                          color: '#4CAF50', 
                          fontWeight: '700',
                          borderBottom: '2px solid rgba(76, 175, 80, 0.5)'
                        }}>Tipo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allPayments
                        .filter(p => p.status === 'approved')
                        .flatMap((payment, paymentIndex) => {
                          const names = payment.names || [];
                          if (names.length === 0) {
                            return [(
                              <tr key={`${payment.paymentId}-empty`} style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                                <td style={{ padding: '0.75rem', color: '#ffffff' }}>{payment.paymentId}</td>
                                <td style={{ padding: '0.75rem', color: '#ffffff' }}>
                                  {new Date(payment.dateCreated).toLocaleString('pt-BR')}
                                </td>
                                <td style={{ padding: '0.75rem', color: '#ffffff' }}>
                                  R$ {payment.transactionAmount?.toFixed(2).replace('.', ',') || '0,00'}
                                </td>
                                <td style={{ padding: '0.75rem', color: '#ffffff' }}>-</td>
                                <td style={{ padding: '0.75rem', color: '#ffffff' }}>-</td>
                              </tr>
                            )];
                          }
                          return names.map((name, nameIndex) => (
                            <tr 
                              key={`${payment.paymentId}-${nameIndex}`} 
                              style={{ 
                                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                                backgroundColor: nameIndex % 2 === 0 ? 'rgba(255, 255, 255, 0.02)' : 'transparent'
                              }}
                            >
                              {nameIndex === 0 && (
                                <>
                                  <td 
                                    rowSpan={names.length} 
                                    style={{ 
                                      padding: '0.75rem', 
                                      color: '#ffffff',
                                      verticalAlign: 'top',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.1)'
                                    }}
                                  >
                                    {payment.paymentId}
                                  </td>
                                  <td 
                                    rowSpan={names.length} 
                                    style={{ 
                                      padding: '0.75rem', 
                                      color: '#ffffff',
                                      verticalAlign: 'top',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.1)'
                                    }}
                                  >
                                    {new Date(payment.dateCreated).toLocaleString('pt-BR')}
                                  </td>
                                  <td 
                                    rowSpan={names.length} 
                                    style={{ 
                                      padding: '0.75rem', 
                                      color: '#ffffff',
                                      verticalAlign: 'top',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.1)'
                                    }}
                                  >
                                    R$ {payment.transactionAmount?.toFixed(2).replace('.', ',') || '0,00'}
                                  </td>
                                </>
                              )}
                              <td style={{ padding: '0.75rem', color: '#ffffff' }}>
                                {typeof name === 'object' ? name.name : name}
                              </td>
                              <td style={{ padding: '0.75rem', color: '#ffffff' }}>
                                {typeof name === 'object' ? (name.ticketType || 'Ingresso') : (payment.ticketType || 'Ingresso')}
                              </td>
                            </tr>
                          ));
                        })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ) : (
            <div>
              <h3 style={{ color: '#FF9800', marginBottom: '1rem' }}>Pagamentos Aguardando</h3>
              {allPayments.filter(p => p.status !== 'approved').length === 0 ? (
                <p style={{ color: '#ffffff', textAlign: 'center', padding: '2rem' }}>Nenhum pagamento aguardando no momento.</p>
              ) : (
                <div>
                  {allPayments
                    .filter(p => p.status !== 'approved')
                    .map((payment, index) => (
                      <div
                        key={payment._id || index}
                        style={{
                          background: 'rgba(255, 152, 0, 0.1)',
                          border: '1px solid rgba(255, 152, 0, 0.3)',
                          borderRadius: '8px',
                          padding: '1rem',
                          marginBottom: '1rem'
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '0.5rem' }}>
                          <div>
                            <p style={{ color: '#FF9800', fontWeight: '700', margin: 0 }}>
                              ID: {payment.paymentId}
                            </p>
                            <p style={{ color: '#ffffff', fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>
                              Data: {new Date(payment.dateCreated).toLocaleString('pt-BR')}
                            </p>
                            <p style={{ color: '#ffffff', fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>
                              Valor: R$ {payment.transactionAmount?.toFixed(2) || '0.00'}
                            </p>
                            <p style={{ color: '#ffffff', fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>
                              Status: {payment.status || 'Pendente'}
                            </p>
                          </div>
                          <span style={{
                            background: '#FF9800',
                            color: '#ffffff',
                            padding: '0.25rem 0.75rem',
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            fontWeight: '600'
                          }}>
                            {payment.status === 'pending' ? 'Pendente' : payment.status === 'in_process' ? 'Em Processo' : payment.status || 'Aguardando'}
                          </span>
                        </div>
                        <div style={{ marginTop: '0.75rem' }}>
                          <p style={{ color: '#ffffff', fontWeight: '600', marginBottom: '0.5rem' }}>Nomes:</p>
                          <ul style={{ margin: 0, paddingLeft: '1.5rem', color: '#ffffff' }}>
                            {payment.names?.map((name, nameIndex) => (
                              <li key={nameIndex} style={{ marginBottom: '0.25rem' }}>
                                {typeof name === 'object' ? name.name : name} 
                                {typeof name === 'object' ? (name.ticketType ? ` - ${name.ticketType}` : '') : (payment.ticketType ? ` - ${payment.ticketType}` : '')}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <hr />

      <button onClick={adicionarConvidados}>Adicionar Convidados</button>

      <h2>Gerenciar Listas de Nomes</h2>
      <h3>Evento Personalizado</h3>

      <button onClick={clearCustomEventNames}>Limpar Lista de Evento Personalizado</button>
      <button onClick={exportCustomEventNames}>Exportar Nomes Confirmados para o Evento Personalizado (PDF)</button>
      <button onClick={exportCustomEventNamesToExcel}>Exportar Nomes para o Evento Personalizado (.xlsx)</button>

      {/* Modal de Adicionar Evento Personalizado */}
      <Modal
  isOpen={isModalOpen}
  onRequestClose={closeModal}
  contentLabel="Adicionar Evento Personalizado"
  style={{
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      color: '#ffffff',
      backgroundColor: 'rgba(10, 14, 39, 0.95)',
      border: '1px solid rgba(59, 130, 246, 0.3)',
      borderRadius: '16px',
      padding: '25px',
      transform: 'translate(-50%, -50%)'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.7)'
    }
  }}
>
  <h2>Evento Personalizado</h2>
  
  {/* Data do Evento */}
  <div style={{ marginBottom: '1.5rem' }}>
    <label style={{ 
      color: '#ffffff', 
      display: 'block', 
      marginBottom: '0.5rem', 
      fontWeight: '600',
      fontSize: '1rem'
    }}>
      Data do Evento:
    </label>
    <input
      type="date"
      value={customEvent.eventDate}
      onChange={(e) => handleCustomEventChange('eventDate', e.target.value)}
      style={{
        width: '100%',
        padding: '0.75rem 1rem',
        borderRadius: '8px',
        border: '2px solid rgba(59, 130, 246, 0.3)',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: '#ffffff !important',
        fontSize: '1rem',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        outline: 'none'
      }}
      className="custom-date-input"
      onFocus={(e) => {
        e.target.style.borderColor = '#3b82f6';
        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
      }}
      onBlur={(e) => {
        e.target.style.borderColor = 'rgba(59, 130, 246, 0.3)';
        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
      }}
    />
    {customEvent.eventDate && (
      <p style={{ 
        color: 'rgba(255, 255, 255, 0.7)', 
        fontSize: '0.875rem', 
        marginTop: '0.5rem',
        fontStyle: 'italic'
      }}>
        Data selecionada: {new Date(customEvent.eventDate + 'T00:00:00').toLocaleDateString('pt-BR', { 
          day: '2-digit', 
          month: '2-digit', 
          year: 'numeric' 
        })}
      </p>
    )}
  </div>
  <div>
    <label>Nome do Evento:</label>
    <input
      type="text"
      value={customEvent.eventName}
      placeholder="Ex: Festa dos amigos"
      onChange={(e) => handleCustomEventChange('eventName', e.target.value)}
    />
  </div>
  {/* Dia do Evento */}
  <div>
    <label>Dia do Evento:</label>
    <input
      type="text"
      value={customEvent.day}
      placeholder="Ex: Sexta-feira"
      onChange={(e) => handleCustomEventChange('day', e.target.value)}
    />
  </div>

  {/* Pista */}
  <div>
    <label>
      <input
        type="checkbox"
        checked={customEvent.pistaActive}
        onChange={(e) => handleCustomEventChange('pistaActive', e.target.checked)}
      />
      Pista
    </label>
    {customEvent.pistaActive && (
      <input
        type="number"
        value={customEvent.pistaPrice}
        onChange={(e) => handleCustomEventChange('pistaPrice', e.target.value)}
        placeholder="Preço da Pista"
      />
    )}
  </div>

  {/* Camarote */}
  <div>
    <label>
      <input
        type="checkbox"
        checked={customEvent.camaroteActive}
        onChange={(e) => handleCustomEventChange('camaroteActive', e.target.checked)}
      />
      Camarote
    </label>
    {customEvent.camaroteActive && (
      <input
        type="number"
        value={customEvent.camarotePrice}
        onChange={(e) => handleCustomEventChange('camarotePrice', e.target.value)}
        placeholder="Preço do Camarote"
      />
    )}
  </div>

  {/* Camarote Open */}
  <div>
    <label>
      <input
        type="checkbox"
        checked={customEvent.camaroteOpenActive}
        onChange={(e) => handleCustomEventChange('camaroteOpenActive', e.target.checked)}
      />
      Camarote Open
    </label>
    {customEvent.camaroteOpenActive && (
      <input
        type="number"
        value={customEvent.camaroteOpenPrice}
        onChange={(e) => handleCustomEventChange('camaroteOpenPrice', e.target.value)}
        placeholder="Preço do Camarote Open"
      />
    )}
  </div>

  {/* Ingresso */}
  <div>
    <label>
      <input
        type="checkbox"
        checked={customEvent.ingressoActive}
        onChange={(e) => handleCustomEventChange('ingressoActive', e.target.checked)}
      />
      Ingresso
    </label>
    {customEvent.ingressoActive && (
      <input
        type="number"
        value={customEvent.ingressoPrice}
        onChange={(e) => handleCustomEventChange('ingressoPrice', e.target.value)}
        placeholder="Preço do Ingresso"
      />
    )}
  </div>

  {/* Imagem do Evento */}
  <div>
    <label>Imagem do Evento:</label>
    <input type="file" onChange={handleCustomFileChange} />
  </div>

  <button onClick={closeModal}>Fechar</button>
  <button onClick={handleSaveCustomEvent}>Salvar</button>

</Modal>



<Modal
        isOpen={isManageModalOpen}
        onRequestClose={closeManageModal}
        contentLabel="Gerenciar Eventos Personalizados"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            color: '#ffffff',
            backgroundColor: 'rgba(10, 14, 39, 0.95)',
            border: '1px solid rgba(59, 130, 246, 0.3)',
            borderRadius: '16px',
            padding: '25px',
            transform: 'translate(-50%, -50%)'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
          }
        }}
      >
        <h2>Gerenciar Eventos Personalizados</h2>

        {/* Listar eventos personalizados */}
        {customEvents.length > 0 ? (
          <ul>
            {customEvents.map(event => (
              <li key={event._id} style={{ marginBottom: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <p><strong>Nome:</strong> {event.eventName}</p>
                    <p><strong>Data:</strong> {event.eventDate}</p>
                    <p><strong>Dia:</strong> {event.day}</p>
                    <p><strong>Pista:</strong> {event.pistaPrice ? `R$${event.pistaPrice}` : 'N/A'}</p>
                    <p><strong>Camarote:</strong> {event.camarotePrice ? `R$${event.camarotePrice}` : 'N/A'}</p>
                    <p><strong>Camarote Open:</strong> {event.camaroteOpenPrice ? `R$${event.camaroteOpenPrice}` : 'N/A'}</p>
                    <p><strong>Ingresso:</strong> {event.ingressoPrice ? `R$${event.ingressoPrice}` : 'N/A'}</p>
                  </div>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button
                      onClick={() => openEditPricesModal(event)}
                      style={{ backgroundColor: '#2196F3', color: 'white', padding: '5px 10px', borderRadius: '4px', border: 'none', cursor: 'pointer' }}
                    >
                      Editar Preço
                    </button>
                    <button
                      onClick={() => deleteCustomEvent(event._id)}
                      style={{ backgroundColor: 'red', color: 'white', padding: '5px 10px', borderRadius: '4px', border: 'none', cursor: 'pointer' }}
                    >
                      Excluir
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>Nenhum evento personalizado disponível.</p>
        )}

        <button onClick={closeManageModal}>Fechar</button>
      </Modal>

      {/* Modal de Editar Preço */}
      <Modal
        isOpen={editingEventId !== null}
        onRequestClose={closeEditPricesModal}
        contentLabel="Editar Preço do Evento"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            color: '#ffffff',
            backgroundColor: 'rgba(10, 14, 39, 0.95)',
            border: '1px solid rgba(59, 130, 246, 0.3)',
            borderRadius: '16px',
            padding: '25px',
            transform: 'translate(-50%, -50%)',
            maxWidth: '500px',
            width: '90%'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
          }
        }}
      >
        <h2 style={{ color: '#ffffff', marginBottom: '1.5rem' }}>Editar Preço do Evento</h2>
        
        {/* Pista */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ color: '#ffffff', display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <input
              type="checkbox"
              checked={editEventPrices.pistaActive}
              onChange={(e) => handleEditPriceChange('pistaActive', e.target.checked)}
              style={{ marginRight: '0.5rem' }}
            />
            Pista
          </label>
          {editEventPrices.pistaActive && (
            <input
              type="number"
              value={editEventPrices.pistaPrice}
              onChange={(e) => handleEditPriceChange('pistaPrice', e.target.value)}
              placeholder={currentPrices.pistaPrice ? `Valor atual: R$ ${currentPrices.pistaPrice}` : 'Preço da Pista'}
              style={{ width: '100%', padding: '0.5rem', marginTop: '0.5rem', borderRadius: '6px', border: '1px solid rgba(59, 130, 246, 0.3)', color: '#000000' }}
            />
          )}
        </div>

        {/* Camarote */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ color: '#ffffff', display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <input
              type="checkbox"
              checked={editEventPrices.camaroteActive}
              onChange={(e) => handleEditPriceChange('camaroteActive', e.target.checked)}
              style={{ marginRight: '0.5rem' }}
            />
            Camarote
          </label>
          {editEventPrices.camaroteActive && (
            <input
              type="number"
              value={editEventPrices.camarotePrice}
              onChange={(e) => handleEditPriceChange('camarotePrice', e.target.value)}
              placeholder={currentPrices.camarotePrice ? `Valor atual: R$ ${currentPrices.camarotePrice}` : 'Preço do Camarote'}
              style={{ width: '100%', padding: '0.5rem', marginTop: '0.5rem', borderRadius: '6px', border: '1px solid rgba(59, 130, 246, 0.3)', color: '#000000' }}
            />
          )}
        </div>

        {/* Camarote Open */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ color: '#ffffff', display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <input
              type="checkbox"
              checked={editEventPrices.camaroteOpenActive}
              onChange={(e) => handleEditPriceChange('camaroteOpenActive', e.target.checked)}
              style={{ marginRight: '0.5rem' }}
            />
            Camarote Open
          </label>
          {editEventPrices.camaroteOpenActive && (
            <input
              type="number"
              value={editEventPrices.camaroteOpenPrice}
              onChange={(e) => handleEditPriceChange('camaroteOpenPrice', e.target.value)}
              placeholder={currentPrices.camaroteOpenPrice ? `Valor atual: R$ ${currentPrices.camaroteOpenPrice}` : 'Preço do Camarote Open'}
              style={{ width: '100%', padding: '0.5rem', marginTop: '0.5rem', borderRadius: '6px', border: '1px solid rgba(59, 130, 246, 0.3)', color: '#000000' }}
            />
          )}
        </div>

        {/* Ingresso */}
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ color: '#ffffff', display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <input
              type="checkbox"
              checked={editEventPrices.ingressoActive}
              onChange={(e) => handleEditPriceChange('ingressoActive', e.target.checked)}
              style={{ marginRight: '0.5rem' }}
            />
            Ingresso
          </label>
          {editEventPrices.ingressoActive && (
            <input
              type="number"
              value={editEventPrices.ingressoPrice}
              onChange={(e) => handleEditPriceChange('ingressoPrice', e.target.value)}
              placeholder={currentPrices.ingressoPrice ? `Valor atual: R$ ${currentPrices.ingressoPrice}` : 'Preço do Ingresso'}
              style={{ width: '100%', padding: '0.5rem', marginTop: '0.5rem', borderRadius: '6px', border: '1px solid rgba(59, 130, 246, 0.3)', color: '#000000' }}
            />
          )}
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <button
            onClick={closeEditPricesModal}
            style={{ backgroundColor: '#666', color: 'white', padding: '0.75rem 1.5rem', borderRadius: '8px', border: 'none', cursor: 'pointer' }}
          >
            Cancelar
          </button>
          <button
            onClick={saveEventPrices}
            style={{ backgroundColor: '#4CAF50', color: 'white', padding: '0.75rem 1.5rem', borderRadius: '8px', border: 'none', cursor: 'pointer' }}
          >
            Salvar
          </button>
        </div>
      </Modal>

    </div>
  );
}

export default AdminPage;

